import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import { selectListItems } from '../../../../../../redux/library/selector';
import { selectTenantOpennetworkCategoriesListItems, selectOpennetworkCategoryQueryItems, selectOpennetworkCategoryCreatedItem, selectOpennetworkCategoryUpdatedItem } from '../../../../../../redux/tenant-open-network-categories/selector';
import { tenantOpenNetworkCategories } from '../../../../../../redux/tenant-open-network-categories/action';
import DBNCategoryComponent from '../components/dbn-category.component';
import { tenantOpenNetworkDomains } from '../../../../../../redux/tenant-open-network-domains/action';
import { selectTenantOpennetworkDomainsListItems } from '../../../../../../redux/tenant-open-network-domains/selector';

const DBNCategory = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const libraryData = useSelector(selectListItems)
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(25);
    const listDBNDomainsData = useSelector(selectTenantOpennetworkDomainsListItems)
    const listDBNCategoriesData = useSelector(selectTenantOpennetworkCategoriesListItems)
    const queryDBNCategoryData = useSelector(selectOpennetworkCategoryQueryItems)
    const createDBNCategoryData = useSelector(selectOpennetworkCategoryCreatedItem)
    const editDBNCategoryData = useSelector(selectOpennetworkCategoryUpdatedItem)
    const [selectedDbnCategory, setSelectedDbnCategory] = useState<any>({
        Name: '',
        IsSubCategory: false,
        ParentCategoryId: 0,
        Code: '',
        OpenNetworkDomainId: 0,
    })

    const listDBNDomains = () => {
        dispatch(tenantOpenNetworkDomains.list({
            url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-domains/dbn-fetch`,
            entity: 'tenantOpenNetworkDomains',
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",
            }
        }))
    }

    const listDBNCategories = () => {
        dispatch(tenantOpenNetworkCategories.list({
            url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-categories/dbn-fetch`,
            entity: 'tenantOpenNetworkCategories',
            jsonData: {}
        }))
    }

    const queryDBNCategory = (id: Number) => {
        dispatch(tenantOpenNetworkCategories.query({
            url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-categories/dbn-fetch-detail`,
            entity: 'tenantOpenNetworkCategories',
            jsonData: {
                Records: [
                    {
                        Id: id
                    }
                ]
            }
        }))
    }

    const handleInnerFormChange: any = (event: any, field: string) => {
        setSelectedDbnCategory({ ...selectedDbnCategory, [field]: event })
    }

    useEffect(() => {
        if (queryDBNCategoryData?.result?.items) {
            setSelectedDbnCategory(queryDBNCategoryData?.result?.items)
        }
    }, [queryDBNCategoryData])

    useEffect(() => {
        listDBNDomains();
        listDBNCategories();
        setSelectedDbnCategory({
            Name: '',
            IsSubCategory: false,
            ParentCategoryId: 0,
            Code: '',
            OpenNetworkDomainId: 0,
        })
        if (parmas?.id > 0) {
            queryDBNCategory(Number(parmas?.id))
        }
    }, [parmas])

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        if (parmas?.id > 0) {
            await dispatch(tenantOpenNetworkCategories.resetAction({ actionType: 'update' }))
            await dispatch(tenantOpenNetworkCategories.update({
                url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-categories`,
                entity: 'openNetworkTaxonomies',
                jsonData: {
                    Context: {},
                    Records: [
                        selectedDbnCategory
                    ]
                }
            }))
            back();
        } else {
            await dispatch(tenantOpenNetworkCategories.resetAction({ actionType: 'create' }))
            await dispatch(tenantOpenNetworkCategories.create({
                url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-categories`,
                entity: 'openNetworkTaxonomies',
                jsonData: {
                    Context: {},
                    Records: [
                        selectedDbnCategory
                    ]
                }
            }))
            back();
        }
    }

    const back = () => {
        navigate(-1)
    }

    useEffect(() => {
        console.log('createDBNCategoryData', createDBNCategoryData)
    }, [createDBNCategoryData]);

    useEffect(() => {
        console.log('editDBNCategoryData', editDBNCategoryData)
    }, [editDBNCategoryData]);

    useEffect(() => {
        console.log('queryDBNCategoryData', queryDBNCategoryData)
    }, [queryDBNCategoryData]);

    return (
        <>
            {listDBNCategoriesData?.isLoading ||
                queryDBNCategoryData?.isLoading ||
                createDBNCategoryData?.isLoading ||
                editDBNCategoryData?.isLoading ? <PageLoader /> :
                <DBNCategoryComponent
                    handleInnerFormChange={handleInnerFormChange}
                    selectedDbnCategory={selectedDbnCategory}
                    domains={listDBNDomainsData?.result?.items}
                    paginationData={listDBNDomainsData?.result?.pagination}
                    categories={listDBNCategoriesData?.result?.items}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    id={parmas?.id}
                />
            }
        </>
    )
}

export default DBNCategory;